import * as React from "react"
import {signal, useComputed} from "@preact/signals-react";
import {useLocation, matchPath} from "react-router-dom";
import {Collapse} from "@mui/material";

import MaximalLayoutNavSectionVertical from "./index";
import MaximalLayoutNavVerticalItem from "./NavItem";


const sectionOpened = signal(null)

export default function MaximalLayoutNavVerticalList({ path, routes, ...config }) {

    // Group routes have no `path` (only `title`), so key the open state by a
    // stable unique id; otherwise every group shares `undefined` and toggles together.
    const navId = path ?? config.title

    const { pathname } = useLocation()
    // Highlight the parent group whenever one of its children is the active route.
    const childActive = routes?.some(r => r.path && r.path !== 'divider' && matchPath({ path: r.path, end: false }, pathname))

    const handleClick = () => sectionOpened.value = sectionOpened.value !== navId ? navId : null
    const isOpen = useComputed(() => sectionOpened.value === navId)

    return <>
        <MaximalLayoutNavVerticalItem path={path} hasChildren={true} isOpen={isOpen.value} onClick={handleClick} {...config} active={childActive} />

        <Collapse in={isOpen.value} unmountOnExit>
            <MaximalLayoutNavSectionVertical routes={routes} subNav />
        </Collapse>
    </>
}